import { h, Component } from 'preact';

class ArrowUpIcon extends Component {
  render () {
    const { color, size } = this.props;

    return (
      <svg
        fill={color || '#ffffff'}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
        width={size}
        height={size}
      >
        <g
          id="Artboard-4"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          transform="translate(-357.000000, -49.000000)"
        >
          <path
            d="M366.288854,50.5777088 L372,62 L357,62 L362.711146,50.5777088 C363.205124,49.5897518 364.40647,49.1893031 365.394427,49.6832816 C365.781482,49.876809 366.095327,50.190654 366.288854,50.5777088 Z"
            id="Triangle"
            fill={color || '#ffffff'}
          />
        </g>
      </svg>
    );
  }
}

export default ArrowUpIcon;
